import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {CreditEstimatedValue} from "../../credit_calculator/components/CreditEstimatedValue";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {AdditionalFormFieldType} from "../../lead/types/AdditionalFormFieldType";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {PropertyHighlightPrice} from "./PropertyHighlightPrice";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPriceNegotiation = (props: IProps) => {
    const currency = props.property.offer.currency;
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.property.offer.configuration.price_visibility,
        vendorPriceVisibility: props.property.offer.vendor.configuration.price_visibility,
        vendorId: props.property.offer.vendor.id
    });

    if (!props.property.price || !shouldShowPrice) {
        return null;
    }

    const isPublished = props.property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    const gtmData = {
        clickText: InquiryButtonTypeName.NEGOTIATE,
        source: GTMEventApplicationSourceSection.HEADER_NEGOTIATE,
        vendorName: props.property.offer.vendor.name ?? props.property.offer.vendor.id.toString(),
        offerName: props.property.offer.name ?? props.property.offer.id.toString()
    };

    return (
        <div>
            <div>
                <div className={priceInfoWrapper}>
                    <div className={priceInfo}>
                        <PropertyHighlightPrice property={props.property} />
                        <CreditEstimatedValue price={props.property.price} currency={currency} />
                    </div>
                    {props.property.for_sale && isPublished && (
                        <ApplicationModalButton
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="x-small" type="button" onClick={() => openModal(gtmData)} className={buttonStyle}>
                                    Negocjuj cenę
                                </Button>
                            )}
                            vendorId={props.property.offer.vendor.id}
                            offerId={props.property.offer.id}
                            propertyId={props.property.id}
                            source={ApplicationSource.NegotiatePrice}
                            sourceSection={ApplicationSourceSection.MODAL}
                            useAdditionalFormField={AdditionalFormFieldType.NEGOTIATION}
                            currency={props.property?.offer.currency}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

const priceInfoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: 0.5,

    xs: {
        flexDirection: "row",
        gap: 2
    }
});

const priceInfo = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const buttonStyle = css({
    fontSize: "14px",
    minWidth: "-webkit-fill-available",

    xs: {
        minWidth: "fit-content"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {CreditEstimatedValue} from "../../credit_calculator/components/CreditEstimatedValue";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {AdditionalFormFieldType} from "../../lead/types/AdditionalFormFieldType";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";
import {PropertyHighlightPrice} from "./PropertyHighlightPrice";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPriceNegotiation = (props: IProps) => {
    const currency = props.property.offer.currency;
    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: props.property.offer.configuration.price_visibility,
        vendorPriceVisibility: props.property.offer.vendor.configuration.price_visibility,
        vendorId: props.property.offer.vendor.id
    });

    if (!props.property.price || !shouldShowPrice) {
        return null;
    }

    const isPublished = props.property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    const gtmData = {
        clickText: InquiryButtonTypeName.NEGOTIATE,
        source: GTMEventApplicationSourceSection.HEADER_NEGOTIATE,
        vendorName: props.property.offer.vendor.name ?? props.property.offer.vendor.id.toString(),
        offerName: props.property.offer.name ?? props.property.offer.id.toString()
    };

    return (
        <div>
            <div>
                <div className={priceInfoWrapper}>
                    <div className={priceInfo}>
                        <PropertyHighlightPrice property={props.property} />
                        <CreditEstimatedValue price={props.property.price} currency={currency} />
                    </div>
                    {props.property.for_sale && isPublished && (
                        <ApplicationModalButton
                            render={({openModal}) => (
                                <Button variant="filled_primary" size="x-small" type="button" onClick={() => openModal(gtmData)} className={buttonStyle}>
                                    Negocjuj cenę
                                </Button>
                            )}
                            vendorId={props.property.offer.vendor.id}
                            offerId={props.property.offer.id}
                            propertyId={props.property.id}
                            source={ApplicationSource.NegotiatePrice}
                            sourceSection={ApplicationSourceSection.MODAL}
                            useAdditionalFormField={AdditionalFormFieldType.NEGOTIATION}
                            currency={props.property?.offer.currency}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

const priceInfoWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: 0.5,

    xs: {
        flexDirection: "row",
        gap: 2
    }
});

const priceInfo = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5
});

const buttonStyle = css({
    fontSize: "14px",
    minWidth: "-webkit-fill-available",

    xs: {
        minWidth: "fit-content"
    }
});
